import { useState } from 'react';

import { Button, Heading, NotificationBox, RadioGroup, RadioTile, Stack, Stretch, Text } from '@eneco/sparky';
import { NotificationBarProps } from '@eneco/sparky/types';
import { useTracking } from '@eneco/tracking';
import { useContent } from '@sitecore/common';
import { PriceSimulationRenderingExtended } from '@sitecore/types/manual/be/PriceSimulationExtended';
import { Controller, useFormContext } from 'react-hook-form';

import { PriceSimulationFormSchema } from '../schemas/priceSimulationFormSchema';
import { FlowChildProps } from '../types/PriceSimulationSteps';
import { getTrackableFormValues } from '../utils/getTrackableFormValues';

export const CurrentEnergyConsumptionQuestionStep = ({ nextMainStep }: FlowChildProps) => {
  const { fields } = useContent<PriceSimulationRenderingExtended>();
  const { control, getValues } = useFormContext<PriceSimulationFormSchema>();
  const [error, setError] = useState<NotificationBarProps | null>(null);
  const { trackEventBE } = useTracking();

  const onNextClick = () => {
    if (getValues('currentEnergyConsumptionQuestion') === undefined) {
      setError({
        variant: 'error',
        title: fields.currentEnergyConsumptionQuestionStep.errorNotification.value.title,
        text: fields.currentEnergyConsumptionQuestionStep.errorNotification.value.content,
      });
      return;
    }
    trackEventBE('pbt_calculation_known_consumption', {
      status: 'click',
      data: getTrackableFormValues(getValues()),
    });
    nextMainStep();
  };

  return (
    <>
      <Stack gap="2">
        <Heading as="h1" size="M">
          {fields.currentEnergyConsumptionQuestionStep.title.value}
        </Heading>
        <Text>{fields.currentEnergyConsumptionQuestionStep.subTitle.value}</Text>
      </Stack>
      <Stretch>
        <div>
          <Controller
            control={control}
            name={'currentEnergyConsumptionQuestion'}
            render={({ field: { onChange, value } }) => (
              <RadioGroup
                name={'currentEnergyConsumptionQuestion'}
                aria-labelledby={fields.currentEnergyConsumptionQuestionStep.energyConsumptionOptionsList.value.label}
                direction="column"
                value={value?.toString()}
                onValueChange={stringValue => onChange(stringValue === 'true')}>
                <RadioTile value={'true'}>
                  {fields.currentEnergyConsumptionQuestionStep.energyConsumptionOptionsList.value.options.find(
                    option => option.name === 'yes',
                  )?.label ?? 'Ja [Not in Sitecore]'}
                </RadioTile>
                <RadioTile value={'false'}>
                  {fields.currentEnergyConsumptionQuestionStep.energyConsumptionOptionsList.value.options.find(
                    option => option.name === 'no',
                  )?.label ?? 'Nee [Not in Sitecore]'}
                </RadioTile>
              </RadioGroup>
            )}
          />
        </div>
      </Stretch>
      {error && <NotificationBox variant="error" isAlert {...error} />}
      <Button onClick={onNextClick}>{fields.navigation.nextButtonText.value}</Button>
    </>
  );
};
